export enum MarkerSeverity {
  Critical = "critical",
  Warning = "warning",
  Normal = "normal",
  Unknown = "unknown",

  // SmallCase
  critical = "critical",
  warning = "warning",
  normal = "normal",
  unknown = "unknown",
}

export const getMenuForMarkerType = (markerType: MarkerSeverity) => {
  switch (markerType) {
    case MarkerSeverity.Critical:
      return MenuTypes.Errors;
    case MarkerSeverity.Warning:
      return MenuTypes.Warnings;
    case MarkerSeverity.Normal:
      return MenuTypes.Normals;
    case MarkerSeverity.Unknown:
      return MenuTypes.All;
    default:
      return MenuTypes.All;
  }
};

export const getMarkerSeverityFromString = (markerSeverityString: string) => {
  switch (markerSeverityString.toUpperCase()) {
    case MarkerSeverity.Critical.toUpperCase():
      return MarkerSeverity.Critical;
    case MarkerSeverity.Warning.toUpperCase():
      return MarkerSeverity.Warning;
    case MarkerSeverity.Normal.toUpperCase():
      return MarkerSeverity.Normal;
    default:
      return MarkerSeverity.Unknown;
  }
};

export const compareMarkerSeverityPriority = (
  m1: MarkerSeverity | undefined | null,
  m2: MarkerSeverity | undefined | null
): MarkerSeverity => {
  if (!m1 && !m2) return MarkerSeverity.Unknown;
  if (!m1) return m2!;
  if (!m2) return m1!;
  if (m1 === m2) return m1;
  if (m1 === MarkerSeverity.Critical || m2 === MarkerSeverity.Critical)
    return MarkerSeverity.Critical;
  if (m1 === MarkerSeverity.Warning || m2 === MarkerSeverity.Warning)
    return MarkerSeverity.Warning;
  if (m1 === MarkerSeverity.Normal || m2 === MarkerSeverity.Normal)
    return MarkerSeverity.Normal;
  return MarkerSeverity.Unknown;
};

export enum MarkerType {
  UNKNOWN = "Unknown",
  BASEBALL = "Baseball",
  GOLF = "Golf",
  GOLF_BROADCAST = "Golf-Broadcast",
  SOFTBALL = "Softball",
}

export enum MenuTypes {
  All = "All",
  Errors = "Error",
  Warnings = "Warning",
  Normals = "Normal",
  Settings = "Settings",
  Unknown = "Unknown",
}

export const getMarkerSeverityInMenu = (menuChoice: MenuTypes | null) => {
  switch (menuChoice) {
    case MenuTypes.All:
      return [
        MarkerSeverity.Critical,
        MarkerSeverity.Warning,
        MarkerSeverity.Normal,
        MarkerSeverity.Unknown,
      ];
    case MenuTypes.Errors:
      return [MarkerSeverity.Critical];
    case MenuTypes.Warnings:
      return [MarkerSeverity.Warning];
    case MenuTypes.Normals:
      return [MarkerSeverity.Normal];
    default:
      return [
        MarkerSeverity.Critical,
        MarkerSeverity.Warning,
        MarkerSeverity.Normal,
        MarkerSeverity.Unknown,
      ];
  }
};
